import { render, staticRenderFns } from "./FieldsEdit.vue?vue&type=template&id=a384b504"
import script from "./FieldsEdit.vue?vue&type=script&lang=js"
export * from "./FieldsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports